import SwitchButton from "../SwitchButton";
import { tw } from "@careinfo/tailwind";
import { usePushNotifications } from "../../hooks/usePushNotifications";

const PushNofication = () => {
  const { isEnabled, togglePushNotifications } = usePushNotifications();
  return (
    <div className={tw`flex items-center gap-x-2`}>
      <SwitchButton
        value={isEnabled}
        disabled={false}
        onChange={togglePushNotifications}
      />
      <label>Push Notification</label>
    </div>
  );
};

export default PushNofication;
